import { render, staticRenderFns } from "./DependentAndNotEmail.vue?vue&type=template&id=35dc54ba"
import script from "./DependentAndNotEmail.vue?vue&type=script&lang=js"
export * from "./DependentAndNotEmail.vue?vue&type=script&lang=js"
import style0 from "./DependentAndNotEmail.vue?vue&type=style&index=0&id=35dc54ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports